import { ref } from 'vue'
import { isArray } from 'lodash-es'
import type { ApiFileListType } from '@/types/config'
import { cacheManager } from '@/utils/cache-manager'
import { fetchBufferData } from '@/utils/fetchBufferData'
import { API_BUFFER_DATA } from '@/types/config'

let apiFileData: ApiFileListType | null = null
let loadPromise: Promise<ApiFileListType> | null = null

export function useEncryptApiFileData() {
  const getApiFileData = async (): Promise<ApiFileListType> => {
    // 如果已经有数据，直接返回
    if (apiFileData) {
      return apiFileData
    }

    if (loadPromise) {
      return loadPromise
    }

    loadPromise = (async () => {
      const data = await cacheManager.get<ApiFileListType>(API_BUFFER_DATA, () =>
        fetchBufferData(
          `${import.meta.env.VITE_S3_URL}/${import.meta.env.VITE_API_ENTRY_FILE_ADDR}?v=${Date.now()}`.replace(
            /([^:]\/)\/+/g,
            '$1'
          )
        )
      )
      apiFileData = isArray(data) ? data : []
      loadPromise = null
      return apiFileData
    })()

    return loadPromise
  }

  const getApiFileByName = async (apiName: string) => {
    const data = await getApiFileData()
    return data.find((item) => item.apiName === apiName)
  }

  return {
    getApiFileData,
    getApiFileByName
  }
}

// 导出类型以保持兼容性
export type { ApiFileListType }
